<template>
  <section class="pt-7">
    <div v-if="!ownRating" class="w-full flex flex-col sm:flex-row items-center justify-center mb-7">
      <span class="text-sm font-semibold text-body-dark mb-3 sm:mb-0 whitespace-nowrap mr-0 sm:mr-5">{{ $t('text-your-catalogue-rating') }}:</span>
      <div class="w-full sm:w-fit flex justify-center whitespace-nowrap">
        <component
          :is="value <= score ? StarSolid : StarIcon"
          v-for="value in 5"
          :key="value"
          class="w-7 h-7 text-orange hover:text-orange-hover cursor-pointer"
          @click="selectScore(value)"
        />
      </div>
    </div>

    <div v-if="ratings.length" class="flex flex-col space-y-5">
      <div
        v-for="(rating, index) in ratings"
        :key="rating.id"
        :class="[
          'w-full flex',
          index % 2 ? 'justify-end' : 'justify-start'
        ]"
      >
        <OrderRatingPreviewRight
          v-if="index % 2"
          :supplier="{ name: rating.customerName }"
          :item="rating"
          :navigable="false"
          :editable="rating.isOwn"
          @edit="editRating"
        />
        <OrderRatingPreviewLeft
          v-else
          :supplier="{ name: rating.customerName }"
          :item="rating"
          :navigable="false"
          :editable="rating.isOwn"
          @edit="editRating"
        />
      </div>
    </div>
  </section>
</template>

<script setup>
import { useAuthStore } from '@stores/auth';
import { useSelectedStore } from '@stores/selected';
import { useUIStore } from '@stores/ui';
import StarIcon from "@components/icons/outline/star-icon";
import StarSolid from "@components/icons/solid/star-solid";
import OrderRatingPreviewLeft from "@components/order/order-rating/order-rating-preview-left";
import OrderRatingPreviewRight from "@components/order/order-rating/order-rating-preview-right";

const props = defineProps({
  variant: {
    type: Object,
    required: true
  }
});

const auth = useAuthStore();
const store = useSelectedStore();
const ui = useUIStore();
const { $eventBus } = useNuxtApp();
const ratings = ref([]);
const score = ref(0);

const ownRating = computed(() => ratings.value.find((rating) => rating.isOwn));

const syncRatings = (value) => {
  ratings.value = [...(value || [])];
  score.value = ownRating.value?.score || 0;
};

watch(() => props.variant.ratings, syncRatings, { immediate: true });

const selectScore = (value) => {
  if (!auth.isLoggedIn && !checkAuth()) {
    return;
  }
  prepareRatingModal();
  store.setContent(props.variant);
  store.setScore(value);
  store.setRating(ownRating.value || {});
  $eventBus.emit('modal:open', ownRating.value ? 'CATALOGUE_RATING_EDIT' : 'CATALOGUE_RATING_VIEW');
};

const editRating = (rating) => {
  prepareRatingModal();
  store.setContent(props.variant);
  store.setScore(rating.score);
  store.setRating(rating);
  $eventBus.emit('modal:open', 'CATALOGUE_RATING_EDIT');
};

const prepareRatingModal = () => {
  if (ui.displayModal && ui.modalView === 'CATALOGUE_DETAILS') {
    store.setAction('RETURN_TO_CATALOGUE_MODAL');
    $eventBus.emit('modal:close');
  }
};
</script>
